/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `std` - Standard
 * `pro` - Professional
 */
export type KlingModeEnum = (typeof KlingModeEnum)[keyof typeof KlingModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KlingModeEnum = {
  std: "std",
  pro: "pro",
} as const;
